package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class WalletDto(
    val id: String,
    val balance: String,
    val currency: String
)

@Serializable
data class WalletTransactionDto(
    val id: String,
    val type: String,
    val amount: String,
    val balanceAfter: String,
    val description: String,
    val referenceId: String? = null,
    val referenceType: String? = null,
    val createdAt: String
)

@Serializable
data class WalletCheckoutRequest(
    /** Coin plan id: "starter", "popular" or "premium". */
    val planId: String
)

@Serializable
data class WalletConfirmRequest(
    /** Order reference returned by the checkout endpoint. */
    val orderReference: String
)

/**
 * Web checkout: redirect the browser to [pageUrl] (mono's hosted payment
 * page); mono sends the user back afterwards and the order is confirmed by
 * reference.
 */
@Serializable
data class WalletCheckoutDto(
    val orderReference: String,
    /** mono invoice id. */
    val invoiceId: String,
    /** mono hosted payment page to redirect the browser to. */
    val pageUrl: String? = null,
    val amount: String,
    val currency: String,
    val coins: Int
)

@Serializable
data class WalletConfirmDto(
    val wallet: WalletDto,
    /** PENDING, PAID, DECLINED or REFUNDED. */
    val orderStatus: String
)
